import React from 'react';
import createReactClass from 'create-react-class';
import request from '../../helpers/request';
import config from './config/purchaseUnitConfig';
import setViewTitle from '../../helpers/setViewTitle';
import PurchaseUnitForm from './PurchaseUnitForm';

var EditPurchaseUnit = createReactClass({
  componentWillMount() {
    setViewTitle('Bestelleinheit bearbeiten');
  },

  getInitialState() {
    return {
      model: {
        id: this.props.match.params.itemId,
        unitId: this.props.match.params.unitId,
        vendorId: this.props.match.params.vendorId,
      }
    };
  },

  componentDidMount() {
    let { id, unitId, vendorId } = this.state.model;

    request.get({
      url: config.apiUrl + id + '/units/' + unitId,
      success: purchaseUnit => {
        if (this.isMounted()) {
          purchaseUnit.id = id;
          purchaseUnit.vendorId = vendorId;

          this.setState({
            model: purchaseUnit
          });
        }
      }
    });
  },

  submitForm(unit) {
    let { id, unitId } = this.state.model;

    unit.unitId = unitId;

    request.put({
      url: config.apiUrl + id + '/units/' + unitId,
      data: unit,
      success: () => {
        this.props.history.push(`/items/${id}/vendors`);
      }
    });
  },

  render() {
    return (
      <PurchaseUnitForm title="Bestelleinheit bearbeiten" onSubmit={this.submitForm} model={this.state.model} />
    );
  }

});

export default EditPurchaseUnit;



// WEBPACK FOOTER //
// ./src/components/purchaseunits/EditPurchaseUnit.js